var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("IngestRdrFileAction", { ref: "ingestAction" }),
      _vm._v(" "),
      _c("AutoDetectFileAction", { ref: "autodetectAction" }),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            "position-x": _vm.position.x,
            "position-y": _vm.position.y,
          },
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "" } },
            [
              _c(
                "v-list-tile",
                {
                  attrs: {
                    to: { name: "dataset", params: { id: _vm.file.Id } },
                  },
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("description")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-title", [_vm._v("View details")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                {
                  attrs: {
                    href: `/download/${_vm.file.Id}`,
                    title: _vm.file.Name,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadFile()
                    },
                  },
                },
                [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("save_alt")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-list-tile-title", [_vm._v("Download")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { staticClass: "my-2" }),
              _vm._v(" "),
              _vm.reviewIngestionLink
                ? _c(
                    "v-list-tile",
                    { attrs: { to: _vm.reviewIngestionLink } },
                    [
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("rule")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-tile-title", [_vm._v("Review file")]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTenantAdmin
                ? _c(
                    "v-list-tile",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.autodetect(_vm.file.Id)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-tile-avatar",
                        [_c("v-icon", [_vm._v("preview")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-list-tile-title", [
                        _vm._v("Auto-detect file type"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }